export default function forms() {
	let selectLists = document.querySelectorAll('.form-dropdown');

	selectLists.forEach((selectList) => {
		let htmlElement = selectList.querySelector('select');

		let selectedContainer = selectList.querySelector(
			'.form-dropdown__selected'
		);
		// console.log(htmlElement);
		// console.log(selectedContainer);

		// Create new dropdown with items.
		let dropdown = document.createElement('ul');
		dropdown.classList.add('form-dropdown__items', 'hide');

		Array.from(htmlElement.options).forEach((optionElement, index) => {
			// Copy all options to the list.
			let item = document.createElement('li');
			item.innerHTML = optionElement.innerHTML;
			item.setAttribute('data-index', index);
			item.addEventListener('click', function (e) {
				// on click show selected item at the top.
				htmlElement.selectedIndex = this.getAttribute('data-index');
				selectedContainer.innerHTML = this.innerHTML;
				selectedContainer.classList.remove('placeholder');
			});
			dropdown.appendChild(item);
		});
		selectList.appendChild(dropdown);

		// Open dropdown on click.
		selectedContainer.addEventListener('click', function (e) {
			e.stopPropagation();
			dropdown.classList.toggle('hide');
			this.classList.toggle('select-arrow-active');
		});
	});

	const closeAllSelect = () => {
		document
			.querySelectorAll('.form-dropdown .select-arrow-active')
			.forEach((item) => {
				item.classList.remove('select-arrow-active');
			});

		document
			.querySelectorAll('.form-dropdown .form-dropdown__items')
			.forEach((item) => {
				item.classList.add('hide');
			});
	};

	document.addEventListener('click', closeAllSelect);
	// Fix accessibility issue: Remove aria-expanded from textareas
	// aria-expanded should only be used on elements that can expand/collapse (like buttons, menus)
	// not on form inputs like textareas
	const fixTextareaAriaExpanded = () => {
		const textareas = document.querySelectorAll('textarea[aria-expanded]');
		textareas.forEach((textarea) => {
			textarea.removeAttribute('aria-expanded');
		});
	};

	// Run immediately and also observe for dynamically added forms
	fixTextareaAriaExpanded();

	// Use MutationObserver to catch dynamically added forms (like Intelex forms)
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.addedNodes.length) {
				mutation.addedNodes.forEach((node) => {
					if (node.nodeType === 1) { // Element node
						// Check if the added node is a textarea with aria-expanded
						if (node.tagName === 'TEXTAREA' && node.hasAttribute('aria-expanded')) {
							node.removeAttribute('aria-expanded');
						}
						// Check for textareas within the added node
						const textareas = node.querySelectorAll?.('textarea[aria-expanded]');
						if (textareas) {
							textareas.forEach((textarea) => {
								textarea.removeAttribute('aria-expanded');
							});
						}
					}
				});
			}
		});
	});

	// Observe the document body for changes
	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
}
